import { initializeApp, getApps, getApp, SDK_VERSION } from 'firebase/app';
import {
  getAuth,
  browserLocalPersistence,
  setPersistence,
} from 'firebase/auth';
import { environment } from 'src/environments/environment';

const firebaseConfig = environment.firebaseConfig;

// ✅ Shared Firebase App instance
export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

// ✅ Shared Firebase Auth instance
export const firebaseAuth = getAuth(firebaseApp);

// ✅ Ensure local persistence is set before login
export const initializeFirebaseAuthPersistence = (): Promise<void> => {
  return setPersistence(firebaseAuth, browserLocalPersistence)
    .then(() => {
      console.log('[Firebase] Local persistence set successfully');
    })
    .catch((err) => {
      console.error('[Firebase] Failed to set persistence:', err);
    });
};